import React, { useState } from 'react';
import { Collapse, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { SettingsSection } from 'src/pages/ProjectSettingsPage/components/SettingsSection';
import { SettingsDetailsToggle } from 'src/pages/ProjectSettingsPage/components/SettingsDetailsToggle';
import { GeneralInfoEditor } from 'src/pages/ProjectSettingsPage/GeneralInfoEditor/GeneralInfoEditor';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';
import { DEFAULT_SPACING } from 'src/theme/style-consts';

type Props = {
    projectId: number;
    generalInfo: string | null;
    canEdit: boolean;
};

export const QuotePropertiesSection = ({ projectId, generalInfo, canEdit }: Props) => {
    const [detailsOpen, setDetailsOpen] = useState(false);

    const toggleDetails = () => setDetailsOpen(!detailsOpen);

    return (
        <SettingsSection
            title={ts('project_settings_quote_title', 'Project quote properties')}
            titleAction={
                <Tooltip title={ts('project_settings_quote_explanation', 'Set project specific properties for the quote')}>
                    <InfoOutlinedIcon fontSize="small" sx={{ color: theme.palette.text.secondary }} />
                </Tooltip>
            }
        >
            <Collapse in={detailsOpen}>
                <Typography variant="subtitle1" sx={{ marginBottom: DEFAULT_SPACING }}>
                    {ts('general_information', 'General information')}
                </Typography>
                <GeneralInfoEditor projectId={projectId} initialContent={generalInfo ?? ''} editable={canEdit} />
            </Collapse>
            <SettingsDetailsToggle open={detailsOpen} onToggle={toggleDetails} />
        </SettingsSection>
    );
};
